import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantAdditionalIncomePage = {
  alert: {
    error: 'applicant-additional-income.alert.error',
  },
  footer: {
    root: 'applicant-additional-income.footer.root',
  },
  form: {
    h1: 'applicant-additional-income.form.h1',
    h2: 'applicant-additional-income.form.h2',
    radioGroupRoot: 'applicant-additional-income.form.radio-group-root',
    radioOption1: 'applicant-additional-income.form.radio-option-1',
    radioOption2: 'applicant-additional-income.form.radio-option-2',
    root: 'applicant-additional-income.form.root',
    submitButton: 'applicant-additional-income.form.submit-button',
  },
  header: {
    previousStepButton:
      'applicant-additional-income.header.previous-step-button',
    root: 'applicant-additional-income.header.root',
    toggleDrawerButton: 'applicant-additional-income.header.drawer-button',
  },
  progress: {
    root: 'applicant-additional-income.progress.root',
  },
} as const satisfies PageLocatorMap;
